export const unixTimeStampFromDate = (date) => Math.floor(date.getTime() / 1000);

export const dateFromUnixTimeStamp = (unixTimeStamp) => new Date(unixTimeStamp * 1000);

export const yesterday = () => {
  let date = new Date();
  date.setDate(date.getDate() - 1);
  return date;
};
